import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { LocationStrategy } from "@angular/common";
import { DomSanitizer } from "@angular/platform-browser";
import { SharedHttp } from "../../../services/http-client.service";
import { ComponentService } from "../../../services/component.service";
import { WebsiteThemeService } from "../../../services/website-theme.service";
/**
 * Wallet Service Not Available Component
 */
let WalletServiceNotAvailableComponent = class WalletServiceNotAvailableComponent {
    constructor(sanitizer, router, httpClient, compService, location, themeService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.httpClient = httpClient;
        this.compService = compService;
        this.location = location;
        this.themeService = themeService;
        this.borderRadiusSmaller = '';
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
        this.router.navigateByUrl('');
    }
};
WalletServiceNotAvailableComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: SharedHttp },
    { type: ComponentService },
    { type: LocationStrategy },
    { type: WebsiteThemeService }
];
WalletServiceNotAvailableComponent = __decorate([
    Component({
        selector: 'ecd-wallet-service-not-available',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./wallet-service-not-available-modal.html")).default
    })
], WalletServiceNotAvailableComponent);
export { WalletServiceNotAvailableComponent };
